<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="primary--text pb-2">Board View Columns</h2>
    </v-flex>
    <v-flex
      sm6 xs12
      :class="{'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp}">
      <v-autocomplete
        dense box
        :items="fields"
        label="Select field for board view"
        v-model="fieldsSelection"
        no-data-text="No results"
        append-icon="keyboard_arrow_down">
      </v-autocomplete>
      <v-autocomplete
        multiple box clearable
        v-model="selectedMultipleChips"
        :items="items"
        :disabled="!fieldsSelection"
        label="Select columns to display"
        no-data-text="No results"
        append-icon="keyboard_arrow_down"
        item-text="name"
        item-value="name">
        <template slot="selection" slot-scope="data">
          <v-chip
            :selected="data.selected"
            close
            class="white--text"
            @input="remove(data.item)"
            color="secondary">
            {{ data.item.name }}
          </v-chip>
        </template>
      </v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"

export default {
  data: () => {
    return {
      selectedMultipleChips: "",
      fieldsSelection: "",
      fields: ["Lorem", "Carpe", "Ipsum"],
      items: [
        { name: "Pending" },
        { name: "Declined" },
        { name: "In Progress" },
        { name: "Shipped" },
        { name: "Delivered" }
      ],
      selectedMultipleFields: ""
    }
  },
  computed: {
    ...mapState({ bucket: state => state.buckets.current.bucket })
  },
  methods: {
    remove(item) {
      const index = this.selectedMultipleChips.indexOf(item.name)
      if (index >= 0) this.selectedMultipleChips.splice(index, 1)
    }
  }
}
</script>
